import { render } from "./ResultMessage.vue?vue&type=template&id=4c54a65a"
import script from "./ResultMessage.vue?vue&type=script&lang=js"
export * from "./ResultMessage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__